module.exports = __webpack_public_path__ + "img/3212c2f.jpg";